import React, { useState, useEffect } from "react";
import "./ClassCards.css";
import { useNavigate } from "react-router-dom";

const ClassCards = () => {
  const navigate = useNavigate();
  const [darkMode, setDarkTheme] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("darkMode");
    if (saved === "true") setDarkTheme(true);
  }, []);

  useEffect(() => {
    localStorage.setItem("darkMode", darkMode);
  }, [darkMode]);

  const classesList = [
    {
      id: 1,
      name: "الصف الثالث الإعدادي",
      cover: "/images/2psaq.png",
      time: "40 ساعة",
      priceAll: "400 جنيه",
      pricePer: "شهر",
    },
    {
      id: 2,
      name: "الصف الأول الثانوي",
      cover: "/images/1paq.png",
      time: "50 ساعة",
      priceAll: "500 جنيه",
      pricePer: "شهر",
    },
    {
      id: 3,
      name: "الصف الثاني الثانوي",
      cover: "/images/2paq.png",
      time: "45 ساعة",
      priceAll: "450 جنيه",
      pricePer: "شهر",
    },
    {
      id: 4,
      name: "الصف الثالث الثانوي",
      cover: "/images/3paq.png",
      time: "60 ساعة",
      priceAll: "600 جنيه",
      pricePer: "شهر",
    },
  ];

  return (
    <section className={`section-catalog ${darkMode ? "dark-mode" : ""}`}>      
      <div className="catalog-grid">
        {classesList.map((item) => (
          <div
            className={`catalog-card ${darkMode ? "dark-mode" : ""}`}
            key={item.id}
          >
            <div className="card-content">
              <h2 className="card-title">{item.name}</h2>
              <div className="card-rating">
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <i className="fa fa-star"></i>
                <label>(5.0)</label>
              </div>
              <p className="card-info">{item.time}</p>
            </div>

            <div className="card-bottom">
           
              <button className="card-btn" onClick={() => navigate("/Login")}>
                سجل الآن!
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ClassCards;